import { inject, injectable } from 'inversify'
import { RequestHandler, requestHandler } from 'mediatr-ts'

import NLPBackendApi from '@infrastructure/backend-apis/nlp/nlp-backend-api'
import { AIPromptsErrorManager } from '@infrastructure/managers/ai/ai-prompts-error-manager'
import { TrackingManager } from '@infrastructure/managers/tracking/tracking-manager'

import { ParaphraseCommand } from './command'

@requestHandler(ParaphraseCommand)
@injectable()
export class ParaphraseCommandHandler
  implements RequestHandler<ParaphraseCommand, string[] | undefined>
{
  constructor(
    @inject(NLPBackendApi) private readonly nlpBackendApi: NLPBackendApi,
    @inject(AIPromptsErrorManager) private readonly aiPromptsErrorManager: AIPromptsErrorManager,
    @inject(TrackingManager) private readonly trackingManager: TrackingManager,
  ) {}

  public async handle({ text, level }: ParaphraseCommand): Promise<string[] | undefined> {
    if (!text) {
      this.aiPromptsErrorManager.handleError({
        code: 'error-generating-ai-empty-body',
      })
      return
    }

    try {
      const { ok, result, error } = await this.nlpBackendApi.paraphrase(text, level)
      if (!ok) {
        this.trackResult(false, level)
        this.aiPromptsErrorManager.handleError(error)
        return
      }

      this.trackResult(true, level)
      return result.paraphrases
    } catch (error: any) {
      this.trackResult(false, level)
      this.aiPromptsErrorManager.handleError(error)
    }
  }

  private trackResult(ableToRespond: boolean, level: string): void {
    this.trackingManager.track('ask-ai', 'rewrite_paraphrase', {
      ableToRespond,
      level: level.toLowerCase(),
    })
  }
}
